import { SupSingleVaultV3 } from "@/types";
import { SupTracker } from "@repo/core-ui";
import React from "react";

interface GridCellAuthenticatedProps {
  vault: SupSingleVaultV3;
}
export default function GridCellAuthenticated({ vault }: GridCellAuthenticatedProps) {
  const isAuthenticated = vault.is_authenticated || (vault.protocol?.is_authenticated ?? false);

  return <SupTracker variant={isAuthenticated ? "success" : "primary"}>{isAuthenticated ? "Authenticated" : "Unauthenticated"}</SupTracker>;
}
